import { TrackingFnType } from '@hooks/useTracking'

const ctaLoginClickHandler: TrackingFnType = () => ({
  event: 'settings_click',
  element: 'cta_login',
})

const ctaLogoutClickHandler: TrackingFnType = () => ({
  event: 'settings_click',
  element: 'cta_logout',
})

const dataProtectionClickHandler: TrackingFnType = () => ({
  event: 'settings_click',
  element: 'dataprotection',
})

const dataProtectionPolicyClickHandler: TrackingFnType = () => ({
  event: 'settings_click',
  element: 'dataprotection_policy',
})

const agbClickHandler: TrackingFnType = () => ({
  event: 'settings_click',
  element: 'agb',
})

const profileClickHandler: TrackingFnType = () => ({
  event: 'settings_click',
  element: 'profile',
})

const subscriptionManagementClickHandler: TrackingFnType = () => ({
  event: 'settings_click',
  element: 'subscription_management',
})

const myTeamsClickHandler: TrackingFnType = () => ({
  event: 'settings_click',
  element: 'my_teams',
})

export type DarkModeTrackingValueType = 'system' | 'dark_mode' | 'light_mode'

const displayClickHandler: TrackingFnType<{
  mode: DarkModeTrackingValueType
}> = ({ extraData: { mode } }) => ({
  event: 'settings_click',
  element: 'display',
  element_status: mode,
})

export {
  ctaLoginClickHandler,
  ctaLogoutClickHandler,
  dataProtectionClickHandler,
  dataProtectionPolicyClickHandler,
  displayClickHandler,
  myTeamsClickHandler,
  profileClickHandler,
  agbClickHandler,
  subscriptionManagementClickHandler,
}
